export default "__VITE_ASSET__BLOYaTem__"